export type TipoCartao = "TEUCARD" | "CONVENIO";

export const TIPO_CARTAO_TEUCARD: TipoCartao = "TEUCARD";
export const TIPO_CARTAO_CONVENIO: TipoCartao = "CONVENIO";
